import { render, staticRenderFns } from "./ProductsReports.html?vue&type=template&id=d57e1852&scoped=true&external"
import script from "./ProductsReports.js?vue&type=script&lang=js&external"
export * from "./ProductsReports.js?vue&type=script&lang=js&external"
import style0 from "./ProductsReports.vue?vue&type=style&index=0&id=d57e1852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57e1852",
  null
  
)

export default component.exports